var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.06 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #18c60b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.24,60c-.59,0-1.06-.47-1.06-1.06v-8.48c0-.59.47-1.06,1.06-1.06s1.06.47,1.06,1.06v8.48c0,.59-.48,1.06-1.06,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.45,50.46h-2.83c-.34,0-.65-.16-.86-.43C-2.69,37.16-2.22,19.58,8.1.51c.37-.68,1.49-.68,1.87,0,10.31,19.07,10.79,36.65,1.34,49.52-.2.27-.52.43-.85.43ZM8.15,48.34h1.75c6.01-8.45,10.44-22.98-.87-45.05-11.32,22.08-6.89,36.6-.88,45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.61,42.17c-.25,0-.51-.09-.71-.27l-5.8-5.22c-.43-.39-.47-1.06-.08-1.5.39-.44,1.06-.47,1.5-.08l5.8,5.22c.43.39.47,1.06.08,1.5-.21.23-.5.35-.79.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.61,33.68c-.25,0-.51-.09-.71-.27L.69,27.82c-.43-.39-.47-1.06-.08-1.5.39-.44,1.06-.47,1.5-.08l6.21,5.59c.43.39.47,1.06.08,1.5-.21.23-.5.35-.79.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.76,26.33c-.25,0-.51-.09-.71-.27l-6.21-5.59c-.43-.39-.47-1.06-.08-1.5.39-.44,1.06-.47,1.5-.08l6.21,5.59c.43.39.47,1.06.08,1.5-.21.23-.5.35-.79.35Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarCount);
export default __webpack_public_path__ + "static/media/ear-count.bb9d6fc5a74211ca8a5f415126f91475.svg";
export { ForwardRef as ReactComponent };